import { render, staticRenderFns } from "./Reel.vue?vue&type=template&id=3e60b888&scoped=true&"
import script from "./Reel.vue?vue&type=script&lang=js&"
export * from "./Reel.vue?vue&type=script&lang=js&"
import style0 from "./Reel.vue?vue&type=style&index=0&id=3e60b888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60b888",
  null
  
)

export default component.exports